export function assignRef(ref,value){return"function"==typeof ref?ref(value):ref&&(ref.current=value),ref}